import { useEffect } from 'react';
import { socket } from '../socket';

export function useAppSocket() {
  useEffect(() => {
    if (localStorage.getItem('authUser')) socket.connect();
    else socket.disconnect();
  }, []);

  useEffect(() => {
    function onConnect() {
      console.log('Connected to socket');
      // setIsConnected(true);
    }

    function onDisconnect() {
      console.log('Socket disconnected');
      // setIsConnected(false);
    }

    socket.on('connect', onConnect);
    socket.on('disconnect', onDisconnect);

    return () => {
      socket.off('connect', onConnect);
      socket.off('disconnect', onDisconnect);
    };
  }, []);

  return null;
}
